import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import { Button, IconButton } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import LaunchIcon from '@mui/icons-material/Launch';
import { formatFirestoreTimestamp } from '../_helpers/mappers';
import ChangeStoreStatusDialog from './ChangeStoreStatusDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflowWrap: 'anywhere',
    padding: theme.spacing(2),
  },
  propertyContainer: {
    '& a': {
      color: 'black',
      textDecoration: 'none'
    }
  },
  label: {
    fontWeight: 'bold',
    marginBottom: 0
  },
  value: {
    display: '-webkit-box',
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical'
  },
  iconButton: {
    marginLeft: 5
  },
  icon: {
    fontSize: 16
  },
  image: {
    border: 'solid 1px #ececec',
    height: 'auto',
    width: 70
  },
  buttonsContainer: {
    '& > *': {
      marginRight: theme.spacing(2),
    },
  }
}));

export default function DetailsPanel({ onDataUpdate, store }) {
  const classes = useStyles();

  const [showChangeStoreStatusDialog, setShowChangeStoreStatusDialog] = useState(false);

  const createdAtFieldName = 'createdAt';
  const updatedAtFieldName = 'updatedAt';

  const androidData = _.get(store, 'platforms.android', {});
  const iOSData = _.get(store, 'platforms.ios', {});

  const copyToClipboard = (value) =>
    navigator.clipboard.writeText(value)

  function TextProperty({ data, label, name }) {
    return (
      <div className={classes.propertyContainer}>
        <p className={classes.label}> {`${label}`}
          <IconButton className={classes.iconButton} onClick={() => copyToClipboard(data[name])}>
            <FileCopyIcon className={classes.icon} />
          </IconButton>
        </p>
        <p className={classes.value}>{data[name] || '-'}</p>
      </div>
    )
  }

  function ImageProperty({ data, label, name }) {
    return (
      <div className={classes.propertyContainer}>
        <a href={data[name]} target="_blank">
          <p className={classes.label}> {`${label}`}
            <IconButton className={classes.iconButton}>
              <LaunchIcon className={classes.icon} />
            </IconButton>
          </p>
          {_.isEmpty(data[name]) ? '-' : <img className={classes.image} src={data[name]} />}
        </a>
      </div>
    )
  }

  function DateProperty({ data, label, name }) {
    return (
      <div className={classes.propertyContainer}>
        <p className={classes.label}> {`${label}`}</p>
        <p className={classes.value}>{formatFirestoreTimestamp(data[name], 'DD/MM/YYYY HH:mm') || '-'}</p>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={2}>
          <TextProperty data={store} label="ID" name={'id'} />
          <TextProperty data={store} label="Status" name="status" />
          <DateProperty data={store} label="Data de cadastro" name={createdAtFieldName} />
          <DateProperty data={store} label="Última atualização" name={updatedAtFieldName} />
        </Grid>

        <Grid item xs={3}>
          <TextProperty data={store} label="Título do aplicativo" name="title" />
          <TextProperty data={store} label="Descrição curta" name="shortDescription" />
          <TextProperty data={store} label="Descrição" name="description" />
          <TextProperty data={store} label="Url da Política de Privacidade" name="privacyPolicyUrl" />
          <TextProperty data={store} label="Palavras chave" name="keywords" />
          <TextProperty data={store} label="Vídeo promocional" name="promotionalVideo" />
        </Grid>

        <Grid item xs={3}>
          <h2>Android</h2>
          <TextProperty data={androidData} label="Url" name="downloadUrl" />
          <TextProperty data={androidData} label="Status" name="publishStatus" />
          <TextProperty data={androidData} label="Nome da conta Google" name="developerAccountName" />
          <TextProperty data={androidData} label="Email da conta Google" name="developerAccountEmail" />
          <DateProperty data={androidData} label="Última solicitação de publicação" name="lastPublishRequestedAt" />
          <DateProperty data={androidData} label="Última atualização de status" name="publishStatusUpdatedAt" />
        </Grid>

        <Grid item xs={2}>
          <h2>iOS</h2>
          <TextProperty data={iOSData} label="Url" name="downloadUrl" />
          <TextProperty data={iOSData} label="Status" name="publishStatus" />
          <TextProperty data={iOSData} label="Team Name" name="teamName" />
          <TextProperty data={iOSData} label="Team ID" name="teamID" />
          <DateProperty data={iOSData} label="Última solicitação de publicação" name="lastPublishRequestedAt" />
          <DateProperty data={iOSData} label="Última atualização de status" name="publishStatusUpdatedAt" />
        </Grid>

        <Grid item xs={2}>
          <ImageProperty data={store} label="Ícone" name="iconUrl" />
          <ImageProperty data={store} label="Tela de introdução" name="launchScreenUrl" />
          <ImageProperty data={store} label="Banner da Play Store" name="featureGraphicUrl" />
        </Grid>

        <Grid alignItems="center" className={classes.buttonsContainer} container direction="row" item justify="flex-start" xs={12}>
          <Button variant="contained" onClick={() => setShowChangeStoreStatusDialog(true)}>Alterar status da loja</Button>
        </Grid>
      </Grid>

      <ChangeStoreStatusDialog
        data={store}
        isOpen={showChangeStoreStatusDialog}
        onClose={() => setShowChangeStoreStatusDialog(false)}
        onDataUpdate={onDataUpdate}
      />
    </div>
  );
}